<div *ngIf="competition_store.data && competition_store.data[0]" myMatchHeight="description__block" class="description">
<ng-container *ngIf="competition_store.data[0] as competition">
  <div class="description__block">
  <div><p class="title"> {{'LEVEL' | transloco}}:</p> <div class="info">
    <p style="font-weight: bold"> {{competition.SubLevel || competition.Level}}</p>
  </div></div>
  </div>
  <div  class="description__block">
      <div><p class="title">{{'DIVISION' | transloco}}:</p>
      <div class="info">
        <p style="font-weight: bold;" *ngFor="let division of competition.ComDivisions">
          {{competition_store.getDivisionById(division)?.Name}}
        </p>
      </div>
  </div>
  </div>
  <div class="description__block">
      <div><p class="title">{{'RECORDS' | transloco}}:</p> <div class="info">
        <p style="font-weight: bold">
        {{competition.WorldRecordStatus == true ? ('WorldRecordsAvailable' | transloco) : ('WorldRecordsNotAvailable' | transloco)}}
      </p>
      </div>
  </div>
  </div>
  <div *ngIf="hasOptions(competition)" class="description__block">
      <div><p class="title">{{'STATUS' | transloco}}:</p> <div class="info">
        <ng-container *ngFor="let status of competition.Options">
          <ng-container [ngSwitch]="status">
            <p *ngSwitchCase="'WRE'" style="font-weight: bold;">
              {{'WorldRankingEvent' | transloco}}
            </p>
            <p *ngSwitchCase="'PWRE'" style="font-weight: bold;">
              {{'ParaWorldRankingEvent' | transloco}}
            </p>
            <p *ngSwitchCase="'WADA'" style="font-weight: bold;">
              {{'AntiDoppingRules' | transloco}}
            </p>
          </ng-container>
        </ng-container>
      </div>
  </div>
  </div>
</ng-container>
  </div>
